import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changeShowModal } from '../../../store/actions/SideMenu';
import { Button } from '../../FormComponents/Button/Button';
import s from '../style/modalStyle.module.scss';

export const ModalAddFaq = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const backToSitesPage = () => {
    history.push(`/help`);
    dispatch(
      changeShowModal({
        nameModal: 'addHelp',
        stateModal: false,
        otherParams: undefined,
      }),
    );
  };

  return (
    <div className={s.modalBox}>
      <div className={s.title}> Done! </div>
      <div className={s.description}>New FAQ was successfully published</div>
      <Button
        text="Back to FAQ`s list"
        type="submit"
        class_type="secondary"
        onClick={() => backToSitesPage()}
      />
    </div>
  );
};
